import { render, staticRenderFns } from "./BDatePicker2WithValidation.vue?vue&type=template&id=5b4a6f9a"
import script from "./BDatePicker2WithValidation.vue?vue&type=script&lang=js"
export * from "./BDatePicker2WithValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports